import React from 'react';
import { PricingVariant } from '@wix/ambassador-pricing-plans-v3-plan/types';
import { TPA_EXPERIMENTS } from '@wix/pricing-plans-common/experiments';
import { VIEWER_HOOKS } from '@wix/pricing-plans-common/hooks';
import { useStyles } from '@wix/tpa-settings/react';
import { useExperiments, useTranslation } from '@wix/yoshi-flow-editor';
import { useStylesParams } from '../../../../../hooks';
import { getVariantValidityCycle } from '../../../../../utils/plan-utils';
import { st, classes } from './Validity.st.css';

export interface ValidityProps {
  variant: PricingVariant | undefined;
  highlighted: boolean;
  className?: string;
}

export const Validity: React.FC<ValidityProps> = ({ variant, highlighted, className }) => {
  const { t } = useTranslation();
  const { experiments } = useExperiments();
  const styles = useStyles();
  const stylesParams = useStylesParams();
  const fontSize = stylesParams.planDurationFontSize ? styles.get(stylesParams.planDurationFontSize) : undefined;
  const isFontSizeEnabled = experiments.enabled(TPA_EXPERIMENTS.FONT_SIZE_FOR_TPA_ELEMENTS);
  const isPluralValidityEnabled = experiments.enabled(TPA_EXPERIMENTS.FIX_TRANSLATIONS);

  const text = getVariantValidityCycle({ variant: variant!, t, isPluralValidityEnabled });

  return (
    <span
      data-hook={VIEWER_HOOKS.PLAN_DURATION}
      className={st(classes.duration, { highlighted }, className)}
      style={isFontSizeEnabled ? { fontSize: `${fontSize}px` } : undefined}
    >
      {text}
    </span>
  );
};
